import React, { useState, useRef, useEffect } from "react";
import { parseDate, getLocaleStringNumber } from '../utils/utils.js';
import { hideGreyBackground, showGreyBackground } from "../utils/windows";
import CustomModal from "../CustomModal";

export const FirstStepContent = ({ setStep, setAbonos, rutConcesionario, lineasAbono, selectedEdsArcoprime, isArcoprime }) => {
  const [valores, setValores] = useState({});
  const [displayModal, setDisplayModal] = useState(false);
  const tableRef = useRef(null);

  const date = new Date();
  const parsedDate = parseDate(date);

  const lineas = Array.isArray(lineasAbono) ? lineasAbono : [];

  useEffect(() => {
    console.log("[FirstStepContent] render props", {
      rutConcesionario,
      isArcoprime,
      selectedEdsArcoprime,
      lineasAbono,
      lineasAbonoIsArray: Array.isArray(lineasAbono),
      lineasAbonoLength: Array.isArray(lineasAbono) ? lineasAbono.length : null,
      valores,
    });

    if (!Array.isArray(lineasAbono)) {
      console.warn("[FirstStepContent] lineasAbono no es array. Se usará [] para evitar caída.", lineasAbono);
    }

    if (Array.isArray(lineasAbono) && lineasAbono.length === 0) {
      console.warn("[FirstStepContent] lineasAbono viene vacío. La tabla se mostrará sin datos.");
    }
  }, [rutConcesionario, isArcoprime, selectedEdsArcoprime, lineasAbono, valores]);

  function openModal() {
    console.log("[FirstStepContent] openModal", {
      totalNumber: getTotalNumber(),
      valores,
    });

    setDisplayModal(true);
    showGreyBackground();
  }

  function closeModal() {
    console.log("[FirstStepContent] closeModal");

    setDisplayModal(false);
    hideGreyBackground();
  }

  function getTotal() {
    let total = 0;

    Object.keys(valores || {}).forEach((key) => {
      if (valores[key]) {
        total += parseInt(valores[key]);
      }
    });

    return getLocaleStringNumber(total);
  }

  function getTotalNumber() {
    let total = 0;

    Object.keys(valores || {}).forEach((key) => {
      if (valores[key]) {
        total += parseInt(valores[key]);
      }
    });

    return total;
  }

  function confirm() {
    console.log("[FirstStepContent] confirm antes de armar abonos", {
      valores,
      lineas,
      lineasLength: lineas.length,
    });

    closeModal();

    const abonos = [];

    Object.keys(valores || {}).forEach((key) => {
      if (valores[key]) {
        const newAbono = {
          linea: key,
          monto: valores[key]
        };

        abonos.push(newAbono);
      }
    });

    console.log("[FirstStepContent] confirm abonos armados", {
      abonos,
      abonosLength: abonos.length,
    });

    setAbonos(abonos);
    setStep(2);
  }

  function changeValor(linea, value) {
    console.log("[FirstStepContent] changeValor", {
      linea,
      value,
    });

    if (value < 0) {
      value = '';
    }

    setValores({ ...valores, [linea]: value });
  }

  function cleanForm() {
    console.log("[FirstStepContent] cleanForm", {
      tableRefExists: !!tableRef.current,
      valores,
    });

    setValores({});

    if (tableRef.current) {
      tableRef.current
        .querySelectorAll("input")
        .forEach((input) => {
          input.value = '';
        });
    }
  }

  return (
    <div className="abonar-en-banco__step-content">
      <table className="abonar-en-banco__table" ref={tableRef}>
        <thead>
          <tr>
            <th>Línea Producto</th>
            <th>Fecha Abono</th>
            <th>Monto</th>
          </tr>
        </thead>
        <tr>
          <th colSpan="3" />
        </tr>
        <tbody>
          {lineas.map((linea, key) =>
            <React.Fragment key={linea.LINEA || key}>
              <tr>
                <td>{linea.DESCRIPCION}</td>
                <td>{parsedDate}</td>
                <td>
                  <div className={`input-with-unit ${isArcoprime && !selectedEdsArcoprime ? "blocked" : ""}`}>
                    <p>$</p>
                    <input
                      type="number"
                      value={valores[linea.LINEA] || ""}
                      onChange={(e) => changeValor(linea.LINEA, e.target.value)}
                      disabled={isArcoprime && !selectedEdsArcoprime}
                    />
                  </div>
                </td>
              </tr>

              {lineas.length - 1 !== key ? (
                <>
                  <tr className="data separator">
                    <td className="trseparator align-left" colSpan="5">
                      <div className="line-sep"></div>
                    </td>
                  </tr>
                </>
              ) : (
                ""
              )}
            </React.Fragment>
          )}
        </tbody>
        <tr>
          <th colSpan="3" />
        </tr>
        <tfoot>
          <tr>
            <td colSpan="2">Total</td>
            <td>$ {getTotal()}</td>
          </tr>
        </tfoot>
      </table>

      <p className="abonar-en-banco__disclaimer">
        <span>Importante:</span> El cliente ha aceptado previamente los términos
        y condiciones de uso del Sitio Internet para pagos Copec S.A..
      </p>

      <hr />

      <div className="abonar-en-banco__step-actions">
        <button
          className={`main-button hallow${getTotalNumber() > 0 ? '' : ' disabled'}`}
          onClick={cleanForm}
          disabled={getTotalNumber() <= 0}
        >
          Limpiar
        </button>

        <button
          className={`main-button${getTotalNumber() > 0 ? '' : ' disabled'}`}
          onClick={openModal}
          disabled={getTotalNumber() <= 0}
        >
          Confirmar
        </button>
      </div>

      <CustomModal
        displayModal={displayModal}
        closeModal={closeModal}
        acceptFunc={confirm}
        acceptText='Confirmar'
        cancelFunc={closeModal}
        modalTitle='Importante'
        modalText='El abono se podrá utilizar para compensar documentos con la misma Linea de Productos.'
        modalIcon='error'
      />
    </div>
  );
};